<template>
  <router-link :to="href" class="link-arrow">
    {{text}}
    <img src="@/assets/img/icons.svg#icon-arrow" width="14" height="10">
  </router-link>
</template>

<script>
  export default {
    name: "LinkArrow",
    props: ['text', 'href']
  }
</script>

<style lang="scss">
  .link-arrow img {
    margin-left: rem(15px);
  }
</style>